import React from "react";
import {Box} from "@mui/material";
import InsertPageBreakOutlinedIcon from "@mui/icons-material/InsertPageBreakOutlined";
import type {NodeViewProps} from "@tiptap/react";
import {useTranslation} from "react-i18next";
import PrintoutBlockShell from "../shared/PrintoutBlockShell";
import {
    PRINTOUT_PAGE_BREAK_FILL_CLASS,
    PRINTOUT_PAGE_BREAK_LABEL_CLASS,
    PRINTOUT_PAGE_BREAK_RULE_CLASS,
} from "./printoutPageBreakOptions";

const PrintoutPageBreakNodeView = (props: NodeViewProps) => {
    const {t} = useTranslation();

    return (
        <PrintoutBlockShell
            {...props}
            blockType="printoutPageBreak"
            icon={<InsertPageBreakOutlinedIcon fontSize="small"/>}
            label="Page break"
        >
            {/* Absolute editor chrome must not contribute to the measured fill height. */}
            {props.editor.isEditable && (
                <Box
                    aria-hidden="true"
                    className={PRINTOUT_PAGE_BREAK_RULE_CLASS}
                    contentEditable={false}
                >
                    <Box className={PRINTOUT_PAGE_BREAK_LABEL_CLASS} component="span">
                        {t("Page break")}
                    </Box>
                </Box>
            )}

            <Box className={PRINTOUT_PAGE_BREAK_FILL_CLASS}/>
        </PrintoutBlockShell>
    );
};

export default PrintoutPageBreakNodeView;
